import { Router } from "@frui.ts/screens";
import EventBus from "services/eventBus";
import ConfirmationService from "services/confirmationService";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import { Modules } from "config";
import EnumRepository from "repositories/enumRepository";
import Road from "entities/road";
import RoadCreateViewModel from "./roadCreateViewModel";
import RoadDetailViewModel from "./roadDetailViewModel";
import ListViewModel from "viewModels/listViewModel";
import type RoadType from "entities/roadType";

const navigationName = "roads";

@Router.registerRoute({ name: Router.Self, route: navigationName, children: [RoadCreateViewModel, RoadDetailViewModel] })
export default class RoadsViewModel extends ListViewModel<Road, RoadDetailViewModel, RoadCreateViewModel> {
  readonly modelName = "road";

  constructor(
    protected createViewModelFactory: () => RoadCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof RoadDetailViewModel.Factory>,
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected securityService: SecurityService
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected fetchData() {
    return this.repository.postAll("roads", Road, {});
  }

  delete(item: Road): any {
    return this.repository.delete(item, "roads");
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `roads.${code}`, size);
  }

  translateRoadType(roadType: RoadType) {
    return this.localizationService.translateEnum("roadType", roadType);
  }
}
